import AuthGuard from "./auth_guard";

export default [
    {
        path: '/targets/my',
        name: 'targets',
        component: () => import('../views/Target/MyTargets.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.targets', customName: null, disabled: false, to: {name: 'targets'} },
            { name: 'msg.my', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/targets/my/:id/diary',
        name: 'targets_diary',
        component: () => import('../views/Target/Diary.vue'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.targets', customName: null, disabled: false, to: {name: 'targets'} },
            { name: null, customName: null, disabled: true, to: {} },
            { name: 'msg.diary', customName: null, disabled: true, to: {} }
        ]
    },
    {
        path: '/targets/feed',
        name: 'feed',
        component: () => import('../views/Target/Feed'),
        beforeEnter: AuthGuard,
        breadcrumbs: [
            { name: 'msg.targets', customName: null, disabled: false, to: {name: 'targets'} },
            { name: 'msg.feed', customName: null, disabled: true, to: {} }
        ]
    },
]